/**
* 统计管理 渠道客户图表
*/
<template>
  <div>
    <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>渠道客户统计</el-breadcrumb-item>
        </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="queryParams" class="user-search">
      <el-form-item label="搜索：" v-if="systemFlag == 1">
        <el-select size="small" v-model="queryParams.orgName" placeholder="请选择客户名称" clearable>
          <el-option v-for="x in clientList" :label="x.orgName" :value="x.orgName" :key="x.orgName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="systemFlag != 1 ? '搜索：' : ''">
        <el-date-picker
          size="small"
          v-model="dateValue"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="list"
      :span-method="objectSpanMethod"
      border
      height="calc(100vh - 250px)"
      style="width: 100%;">
      <el-table-column
        prop="orgName"
        label="客户名称">
      </el-table-column>
      <el-table-column
        prop="subjectName"
        label="考试科目">
      </el-table-column>
      <el-table-column
        prop="gkrs"
        label="购卡人数">
      </el-table-column>
      <el-table-column
        prop="jhrs"
        label="激活人数">
      </el-table-column>
      <el-table-column
        prop="price"
        label="购买单价">
      </el-table-column>
      <el-table-column
        prop="amount"
        label="购卡金额">
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import {queryReportQdList, querySubjectReport} from '../../api/report'
import { timestampToTime } from '../../utils/util'
import Pagination from '../../components/Pagination'
import {queryOrgList} from "../../api/userMG";
export default {
  props: {
    type: String
  },
  data() {
    return {
      systemFlag: JSON.parse(localStorage.getItem('userdata')).systemFlag,

      dateValue: [],
      loading: false, //是显示加载
      queryParams: {
        startTime: '',
        endTime: '',
        // reportType: this.type      SUBJECT,AREA,AGE,MARKETING_CHANNEL
      },
      list: [],

      clientList: [], // 客户下拉选 数据

      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */
  watch: {},
  /**
   * 创建完毕
   */

  created() {
    this.initData();
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {

    initData() {
      // admin 账号 查询客户下拉选
      queryOrgList({page: 1, size: 1000}).then(res => {
        this.clientList = res.data.content
      })
      const currentDate = new Date();
      // this.queryParams.startTime = this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));
      // this.queryParams.endTime = this.formatDate(currentDate)
      this.dateValue.push(this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)));
      this.dateValue.push(this.formatDate(currentDate));

      this.queryParams.startTime = this.dateValue.length > 0 ? timestampToTime(this.dateValue[0]).split(' ')[0] : this.formatDate(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));
      this.queryParams.endTime = this.dateValue.length > 0 ? timestampToTime(this.dateValue[1]).split(' ')[0] : this.formatDate(currentDate);
      this.getdata()
    },

    // 格式化日期函数
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 获取角色列表
    getdata() {
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      queryReportQdList(JSON.stringify(this.queryParams)).then(res => {
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.list = res.data;
        }
      })
        .catch(err => {
          this.$message.error('加载失败，请稍后再试！')
        })
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //第一列合并
      if (columnIndex === 0) {
        const orgName = row.orgName;
        const prevOrgName = rowIndex > 0 ? this.list[rowIndex - 1].orgName : '';
        const nextOrgName = rowIndex + 1 < this.list.length ? this.list[rowIndex + 1].orgName : '';

        if (orgName === prevOrgName) {
          return { rowspan: 0, colspan: 0 };
        } else {
          let count = 1;
          for (let i = rowIndex + 1; i < this.list.length; i++) {
            if (this.list[i].orgName === orgName) {
              count++;
            } else {
              break;
            }
          }
          return { rowspan: count, colspan: 1 };
        }
      }
      return { rowspan: 1, colspan: 1 };
    },

    // 搜索事件
    search() {
      const currentDate = new Date();
      this.queryParams.startTime = this.dateValue != null ? timestampToTime(this.dateValue[0]).split(' ')[0] : '';
      this.queryParams.endTime = this.dateValue != null ? timestampToTime(this.dateValue[1]).split(' ')[0] : '';
      this.getdata()
    },

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}

.onlyCss {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 98.5%;
  height: 70vh;
  background-color: #f6f6f6;
  border-right: 8px !important;
  margin: 10px;
}
.twoCss {
  width: 80%;
  height: 80%;
}

/deep/ .el-table {
  display: flex;
  flex-direction: column;
}

/deep/ .el-table__header-wrapper {
  overflow: unset !important;
}

</style>




// WEBPACK FOOTER //
// src/views/statistics/channelStatistics.vue